import Link from "next/link";
import Menu from "../Menu";
import { IconPhoneCall, IconCalendarEvent } from "@tabler/icons-react";

export default function Header2({ scroll }) {
  return (
    <>
      <header
        id="header-main"
        className={`header style-1 no-boder ${scroll ? "scrollHeader" : ""}`}
        style={{ top: "0" }}
      >
        <div className="header-inner">
          <div className="header-inner-wrap w-1840">
            <button
              type="button"
              className="mobile-button"
              data-bs-toggle="offcanvas"
              data-bs-target="#menu-mobile"
              aria-controls="menu-mobile"
              aria-expanded="false"
              aria-label="Open menu"
            >
              <i className="icon-menu" aria-hidden="true" />
            </button>

            <div className="header-left">
              <div className="header-logo">
                <Link
                  href="/"
                  className="site-logo"
                  aria-label="Pro Ear Clinic"
                >
                  <img
                    id="logo_header"
                    alt="Pro Ear Clinic"
                    src="/images/logo/Logo-pro-ear-clinic.svg"
                    data-retina="/images/logo/Logo-pro-ear-clinic.svg"
                    width={148}
                    height={52}
                    loading="eager"
                    fetchPriority="high"
                  />
                </Link>
              </div>
              <nav className="main-menu">
                <Menu />
              </nav>
            </div>

            {/* Desktop/tablet CTAs */}
            <div className="header-right hidden sm:block">
              <div className="flex items-center gap-4">
                <div className="btn-get">
                  <Link
                    className="tf-btn style-default btn-color-secondary pd-40 flex items-center gap-2"
                    href="tel:+441174410770"
                    target="_blank"
                  >
                    <IconPhoneCall size={24} stroke={2} />
                    <span>Call anytime: 0117 441 0770</span>
                  </Link>
                </div>
                <div className="btn-get">
                  <Link
                    className="tf-btn style-default btn-color-teal pd-40 flex items-center gap-2"
                    href="https://pro-ear-clinic-ltd.uk2.cliniko.com/bookings"
                    target="_blank"
                  >
                    <IconCalendarEvent size={24} stroke={2} color="#fff" />
                    <span>Get Your Appointment</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile-only CTA row (side-by-side, equal height) */}
      <div className="sm:hidden px-4 mt-3 mb-12">
        <div className="grid grid-cols-2 gap-3">
          <Link
            href="tel:+441174410770"
            target="_blank"
            className="w-full h-14 flex items-center justify-center gap-2 rounded-full bg-orange-200 text-brown-900 font-semibold"
            aria-label="Call Pro Ear Clinic"
          >
            <IconPhoneCall size={22} stroke={2} />
            <span>Call Anytime</span>
          </Link>

          <Link
            href="https://pro-ear-clinic-ltd.uk2.cliniko.com/bookings"
            target="_blank"
            className="w-full h-14 flex items-center justify-center gap-2 rounded-full bg-teal-700 text-white font-semibold"
            aria-label="Book an appointment"
          >
            <IconCalendarEvent size={22} stroke={2} />
            <span>Book an appointment</span>
          </Link>
        </div>
      </div>
    </>
  );
}
